export class Feeds{
    category:any;
    domain:any;
    description:any;
    link:any;
    tags:string[]=[];
    id:any;
    createdDate:any;
    linkMetaData:any;
    contentDetails: any;
    userId:any;

}